<template>
  <div>
    <CRow>
      <CCol sm="12">&nbsp;</CCol>
      <CCol sm="12">
        <GlobalTable
          :title="title + ' List'"
          :fields="fields"
          :items="data"
          :editButton="true"
          :redirectDetail="false"
          :enableAddButton="true"
          :isLoading="isLoading"
          :withCard="false"
          @addForm="addForm"
          @editForm="editForm"
          @previewForm="previewForm"
        ></GlobalTable>
      </CCol>
    </CRow>

    <CModal
      title="Modal title"
      color="success"
      size="xl"
      :closeOnBackdrop="false"
      :show.sync="addButton"
    >
      <template #header>
        <h6 class="modal-title" v-if="isEdit == true">Edit Form {{ title }}</h6>
        <h6 class="modal-title" v-if="isEdit == false">Add Form {{ title }}</h6>
      </template>

      <Loading v-if="isLoading"></Loading>
      <CForm v-else>
        <CRow>
          <CCol sm="9">
              <label for="messages">Messages</label>
              <quill-editor style="height: 200px; margin-bottom:70px;"
                :content="content"
                :options="editorOption"
                v-model="$v.complaintDetailForm.messages.$model"
                @change="onEditorChange($event)">
              </quill-editor>
              <div v-if="$v.complaintDetailForm.messages.$invalid" class="invalid-feedback-custom">
                Messages harus di isi.
              </div>
            </CCol>
            
            <!-- <CCol sm="6">
            <CTextarea
              label="Messages"
              invalid-feedback="Messages should be filled"
              required
              v-model="$v.complaintDetailForm.messages.$model"
              :is-valid="!$v.complaintDetailForm.messages.$invalid"
              :rows="4"
            ></CTextarea>
          </CCol> -->
        </CRow>
        <CRow>
          

          <CCol lg="6">
            <CRow>
              <CCol lg="6">
                <template v-if="imgPreviewUrl === null && imgPreview === null">
                  <CInputFile
                    ref="fileupload"
                    label="Attachment"
                    accept="image/*"
                    invalid-feedback="Attachment should be filled"
                    required
                    @change="onFileChange"
                  />
                  <CButton @click="removeImage" color="danger">
                    <i class="fa fa-remove"></i>
                    Remove
                  </CButton>
                </template>
                <template v-else-if="imgPreviewUrl !== null && imgPreview === null">
                  <CButton @click="removeAttachment" color="danger">
                    <i class="fa fa-remove"></i>
                    Remove Attachment
                  </CButton>
                </template>
              </CCol>
              <CCol lg="6">
                <CImg
                  v-if="imgPreviewUrl === null && imgPreview !== null"
                  :src="imgPreview"
                  :width="200"
                  :thumbnail="true"
                />
                <CImg
                  v-else-if="imgPreviewUrl !== null && imgPreview === null"
                  :src="
                    'https://storage.googleapis.com/isikulkas/' +
                    imgPreviewUrl +
                    '?r=' +
                    unixTime
                  "
                  :width="200"
                  :thumbnail="true"
                />
              </CCol>
            </CRow>
          </CCol>
        </CRow>
      </CForm>

      <template #footer>
        <CButton @click="cancelForm" color="danger">
          <i class="fa fa-undo"></i>
          Cancel
        </CButton>
        <CButton
          @click="submitForm"
          :disabled="$v.complaintDetailForm.$invalid"
          color="success"
        >
          <i class="fa fa-save"></i>
          Accept
        </CButton>
      </template>
    </CModal>

    <CModal
      title="Image Preview"
      color="success"
      size="lg"
      :closeOnBackdrop="false"
      :show.sync="preview"
    >
      <CImg
        :src="
          'https://storage.googleapis.com/isikulkas/' +
          complaintDetailForm.attachment +
          '?r=' +
          unixTime
        "
        :thumbnail="true"
      />
    </CModal>
  </div>
</template>

<script>
import Loading from "../../../templates/Loading";
import GlobalTable from "../../../templates/Table";
import tableInterfaces from "@/templates/_table_interfaces.js";
import { required } from "vuelidate/lib/validators";

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'

export default {
  name: "Respond_List",
  components: { GlobalTable, Loading, quillEditor },
  data() {
    return {
      title: "Respond List",
      activeTab: 0,
      fields: [
        { key: "messages", label: "Messages", sorter: true },
        { key: "response_name", label: "Response By", sorter: true },
        { key: "response_time", label: "Response Time", sorter: true },
        { key: "action", _classes: "text-center action" },
      ],
      complaintDetailForm: tableInterfaces.complaint_detail,
      userForm: tableInterfaces.users,
      addButton: false,
      preview: false,
      items: [],
      isEdit: false,
      isLoading: false,
      unixTime: Math.floor(Math.random() * (0 - 9999999999 + 1)) + 0,
      imgPreviewUrl: null,
      imgPreview: null,
      content: '',editorOption: {},	
    };
  },
  props: {
    complaintData: {
      type: [Array, Object],
      default: () => [],
    },

    complaints: {
      type: [Array, Object],
      default: () => [],
    },
  },
  validations: {
    complaintDetailForm: {
      messages: { required },
      response_by: {},
      response_time: {},
      complaint_id: {},
      attachment: {},
    },
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },

  computed: {
    data: function () {
      return this.items.length > 0 ? this.items : this.complaintData;
    },
  },

  methods: {
    init: function () {
      this.isEdit = false;
      this.unixTime = Math.floor(Math.random() * (0 - 9999999999 + 1)) + 0;
    },
    refreshComplaintDetail: function (id) {
      this.isLoading = true;
      this.axios
        .get("console/complaint/listing-detail/" + id)
        .then((response) => {
          if (response.data.status === 2000) {
            this.items = response.data.data;
            this.showInfoNotification({
              title: this.title,
              message: response.data.message,
            });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
          this.cancelForm();
        });
    },
    submitForm: function (event) {
      event.preventDefault();
      this.complaintDetailForm.complaint_id = this.complaints.id;
      this.complaintDetailForm.order_number = this.complaints.order_number;

      // console.log(this.complaintDetailForm)
      if (this.isEdit === false) {
        if (confirm("Do you want to add this data ?")) {
          this.isLoading = true;
          this.axios
            .post("console/complaint/add-response", this.complaintDetailForm)
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: this.title,
                  message: response.data.message,
                });
              } else {
                this.showErrorNotification({
                  title: this.title,
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.showErrorNotification({
                title: this.title,
                message: error,
              });
            })
            .finally(() => {
              this.isLoading = false;
              this.imgPreview = null;
              this.imgPreviewUrl = null;
              this.refreshComplaintDetail(this.complaints.id);
            });
        }
      } else {
        if (confirm("Do you want to update this data ?")) {
          this.isLoading = true;
          this.axios
            .put("console/complaint/update-response", this.complaintDetailForm)
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: this.title,
                  message: response.data.message,
                });
              } else {
                this.showErrorNotification({
                  title: this.title,
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.showErrorNotification({
                title: this.title,
                message: error,
              });
            })
            .finally(() => {
              this.isLoading = false;
              this.imgPreview = null;
              this.imgPreviewUrl = null;
              this.refreshComplaintDetail(this.complaints.id);
            });
        }
      }
    },
    addForm: function () {
      this.addButton = true;
      this.isEdit = false;
      this.imgPreview = null;
      this.imgPreviewUrl = null;
      this.resetForm();
      this.complaintDetailForm.raw_attachment = null;
    },
    previewForm: function () {
      this.preview = true;
      this.isEdit = false;
      this.addButton = false;
    },
    editForm: function (item) {
      this.isEdit = true;
      this.complaintDetailForm = item;
      this.complaintDetailForm.raw_attachment = null;
      if (item.attachment !== null) {
        this.imgPreviewUrl = item.attachment;
        this.imgPreview = null;
      } else {
        this.imgPreview = null;
        this.imgPreviewUrl = null;
      }
      this.addButton = true;
    },
    resetForm: function () {
      for (var i in tableInterfaces.complaint_detail) {
        tableInterfaces.complaint_detail[i] = null;
      }
      this.complaintDetailForm = tableInterfaces.complaint_detail;
    },
    cancelForm: function () {
      this.addButton = false;
      this.preview = false;
      this.resetForm();
    },
    onFileChange(e) {
      this.createImage(e[0]);
    },
    createImage(file) {
      var image = new Image();
      var reader = new FileReader();
      var vm = this;
      reader.onload = (e) => {
        vm.image = e.target.result;
        this.complaintDetailForm.raw_attachment = e.target.result;
        this.imgPreview = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    removeImage: function (e) {
      this.complaintDetailForm.attachment = null;
      this.imgPreview = null;
    },
    removeAttachment: function (e) {
      if (confirm("Do you want to remove this attachment ?")) {
        this.complaintDetailForm.attachment = null;
        this.imgPreview = null;
        this.isLoading = true;
        var remove = {
          images: this.complaintDetailForm.attachment,
          id: this.complaintDetailForm.id,
        };
        this.axios
          .put("console/complaint/remove-attachment", remove)
          .then((response) => {
            this.$refs.uploaimage.reset();
            this.$refs.fileupload.value = null;
            this.uploadImageForm.images = null;
            this.products.images = null;
          })
          .catch((error) => {
            this.expired(error, "Ubah Product Issue");
          })
          .finally(() => {
            this.isLoading = false;
            this.refreshComplaintDetail(this.complaints.id);
          });
      }
    },

    onEditorChange({ quill, html, text }) {
      this.content = html
      this.complaintDetailForm.messages = html
    },
  },
  mounted() {
    this.init();
  },
};
</script>
